import { FarmResponse, FieldListField } from "models";

export const autoSelectFarm = (farms: FarmResponse[], currentFarmId: string): FarmResponse | null => {
  if (farms.length === 0) return null;
  return farms.find((f) => f.id === currentFarmId) ?? farms[0];
};

export const autoSelectLargestField = (fields: FieldListField[]): FieldListField | null => {
  if (fields.length === 0) return null;
  return [...fields].sort((a, b) => (b.size ?? 0) - (a.size ?? 0))[0];
};
